import { gql } from "graphql-request";

export const GENERATE_EXPORT = gql`
  query GenerateExport($input: ExportGenerateInput) {
    GenerateExport(input: $input)
  }
`;
